import React, { useEffect, useState } from 'react';
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  DialogActions,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
} from '@mui/material';
import ChipInput from '../../commun/ChipInput';
import './Addmission.css';
import { fetchSkillsFromLightcast } from '../../../services/lightcastApi';
import { parseSecteursExcel } from '../../commun/autofillExcel';
import {
  contractTypeOptions,
  languageOptions,
  languageLevelOptions,
} from '../../commun/constants/options';
import { IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Grid } from '@mui/system';
import { secteurOptions as initialSecteurs } from '../../commun/constants/options'

const StepTwo = ({ data, errors, onChange }) => {
  const [skillSuggestions, setSkillSuggestions] = useState([]);
  const [query, setQuery] = useState('');
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const [errorContract, setErrorContract] = useState('');
  const [selectedContract, setSelectedContract] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  // const [tarif, setTarif] = useState('');
  const [devise, setDevise] = useState('EUR');
  const [secteurOptions, setSecteurOptions] = useState(initialSecteurs);
  const [newSecteur, setNewSecteur] = useState('');
  const [showAddField, setShowAddField] = useState(false);
  const [tarifMin, setTarifMin] = useState("");
  const [tarifMax, setTarifMax] = useState("");

  const handleAddSecteur = async () => {
    const trimmed = newSecteur.trim();
    if (!trimmed) return;
  
    // Prevent duplicates by checking libelle
    if (secteurOptions.some(opt => opt.libelle === trimmed)) return;
  
    try {
      const response = await fetch(`${API_BASE}/api/missions/secteur`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: trimmed }),
      });
  
      const data = await response.json();
  
      if (response.ok) {
        const newSecteurObject = {
          code: data.secteur?.code || data.secteur?.id || data.secteur?.name || data.secteur, // fallback
          libelle: data.secteur?.name || data.secteur?.libelle || trimmed,
        };
  
        setSecteurOptions((prev) => [...prev, newSecteurObject]);
        onChange('secteur', newSecteurObject.code); 
        setNewSecteur('');
        setShowAddField(false);
      } else {
        alert(data.error || 'Erreur lors de l’ajout du secteur.');
      }
    } catch (error) {
      console.error(error);
      alert('Erreur serveur lors de l’ajout du secteur.');
    }
  };
  

  useEffect(() => {
    if (query.trim().length > 2) {
      const delayDebounce = setTimeout(() => {
        fetchSkillsFromLightcast(query.trim())
          .then((skills) => {
            setSkillSuggestions(skills || []);
          })
          .catch(console.error);
      }, 500);
      return () => clearTimeout(delayDebounce);
    } else {
      setSkillSuggestions([]);
    }
  }, [query]);


  
  const handleLangueChange = (index, field, value) => {
    const updated = [...data.langues];
    updated[index] = {
      ...updated[index],
      [field]: value,
    };
    onChange('langues', updated);
  };

  const addLangue = () => {
    const updated = [...data.langues, { langue: '', niveau: '' }];
    onChange('langues', updated);
  };

  const removeLangue = (index) => {
  const updated = data.langues.filter((_, i) => i !== index);
  onChange('langues', updated);
};

const handleOpenDialog = () => {
  setErrorContract('');
  setOpenDialog(true);
};

const handleCloseDialog = () => {
  setErrorContract('');
  setOpenDialog(false);
};

const handleAddContract = () => {
  const existing = data.typeContratDetails || [];

  const alreadyExists = existing.some((item) => item.contrat === selectedContract);
  if (alreadyExists) {
    setErrorContract("Ce type de contrat a déjà été ajouté.");
    return;
  }

  if (selectedContract && tarifMax && devise) {
    const updated = [...existing, { contrat: selectedContract, tarifMin,tarifMax, devise }];
    onChange('typeContratDetails', updated);
    setSelectedContract('');
    setTarifMax('');
    setTarifMin('');
    setDevise('EUR');
    setErrorContract('');
    setOpenDialog(false);
  } else {
    setErrorContract("Veuillez remplir tous les champs.");
  }
};


  const handleRemoveContract = (index) => {
    const updated = [...(data.typeContratDetails || [])];
    updated.splice(index, 1);
    onChange('typeContratDetails', updated);
  };

  const currencySelector = (
    <InputAdornment position="end">
      <FormControl variant="standard" sx={{ minWidth: 60 }}>
        <Select
          value={devise}
          onChange={(e) => setDevise(e.target.value)}
          disableUnderline
        >
          <MenuItem value="EUR">EUR</MenuItem>
          <MenuItem value="MAD">MAD</MenuItem>
          <MenuItem value="TND">TND</MenuItem>
          <MenuItem value="EGP">EGP</MenuItem>
        </Select>
      </FormControl>
    </InputAdornment>
  );

  return (
    <form className="step-two-container">
      <ChipInput
        label="Compétences clés"
        required
        values={data.competences}
        onChange={(newValues) => onChange('competences', newValues)}
        onInputChange={(input) => setQuery(input)}
        suggestions={skillSuggestions}
        error={!!errors.competences}
        helperText={errors.competences}
      />
      <TextField
        label="Années d'expérience"
        value={data.experience}
        error={!!errors.experience}
        helperText={errors.experience}
        onChange={(e) => onChange('experience', e.target.value)}
        className="step-two-half"
      />
      <TextField
      label="Informations complémentaires"
      value={data.infoComplementaires || ''}
      onChange={(e) => onChange('infoComplementaires', e.target.value)}
      className="step-two-half"
      multiline
      minRows={1}
      error={!!errors.infoComplementaires}
      helperText={errors.infoComplementaires}
      />

    <div className="secteur-section">
      <FormControl fullWidth margin="normal" error={!!errors.secteur}>
        <InputLabel>Secteur d'activité</InputLabel>
        <Select
          value={data.secteur || ''}
          onChange={(e) => onChange('secteur', e.target.value)}
          label="Secteur d'activité"
        >
        {secteurOptions.map((option) => (
          <MenuItem key={option.code} value={option.libelle}>
            {option.libelle}
          </MenuItem>
        ))}
        </Select>
      </FormControl>

      {showAddField ? (
        <Box display="flex"  alignItems="center" gap={2}>
          <TextField
            label="Nouveau secteur"
            value={newSecteur}
            onChange={(e) => setNewSecteur(e.target.value)}
            variant="outlined"
            size="small"
          />
          <Button variant="contained" onClick={handleAddSecteur}>
            Ajouter
          </Button>
          <Button variant="text" onClick={() => setShowAddField(false)}>
            Annuler
          </Button>
        </Box>
      ) : (
        <Button
          variant="outlined"
          onClick={() => setShowAddField(true)}
        >
          Ajouter un secteur
        </Button>
      )}
   </div>

   <div className="langues-section">
        <Button variant="outlined" onClick={addLangue} className="ajouter-langue-btn">
          + Ajouter une langue
        </Button>
        {(data.langues || []).map((entry, index) => (
          <div className="langue-row" key={index} style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <FormControl className="step-two-half">
              <InputLabel>Langue</InputLabel>
              <Select
                value={entry.langue || ''}
                onChange={(e) => handleLangueChange(index, 'langue', e.target.value)}
                label="Langue"
              >
                {languageOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl className="step-two-half">
              <InputLabel>Niveau</InputLabel>
              <Select
                value={entry.niveau || ''}
                onChange={(e) => handleLangueChange(index, 'niveau', e.target.value)}
                label="Niveau"
              >
                {languageLevelOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Tooltip title="Supprimer cette langue">
              <IconButton
                onClick={() => removeLangue(index)}
                color="error"
                className="delete-langue-btn"
                size="small"
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </div>
        ))}
      </div>

      <TextField
        label="Formation"
        value={data.formation}
        error={!!errors.formation}
        helperText={errors.formation}
        onChange={(e) => onChange('formation', e.target.value)}
        className="step-two-half"
      />

      <FormControl fullWidth>
        <Button
          variant="outlined"
          color={
            errors.typeContratDetails || !(data.typeContratDetails?.length)
              ? 'error'
              : 'primary'
          }
          onClick={handleOpenDialog}
        >
          Type(s) de contrat(s) proposé(s)
        </Button>
      </FormControl>

      <div className="chips-container">
        {(data.typeContratDetails || []).map((item, index) => (
          <div key={index} className="chip-item">
            <span className="chip-label">{`${item.contrat} : ${item.tarifMin} ${item.devise} - ${item.tarifMax} ${item.devise}`}</span>
            <IconButton size="small" onClick={() => handleRemoveContract(index)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </div>
        ))}
      </div>

      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Ajouter un type de contrat</DialogTitle>

        <DialogContent>
          <FormControl fullWidth margin="normal">
            <InputLabel>Type</InputLabel>
            <Select
              value={selectedContract}
              onChange={(e) => setSelectedContract(e.target.value)}
              label="Type"
            >
              {contractTypeOptions.map((option) => {
                const isAlreadyAdded = (data.typeContratDetails || []).some(
                  (item) => item.contrat === option.label
                );
                return (
                  <MenuItem
                    key={option.label}
                    value={option.label}
                    disabled={isAlreadyAdded} 
                  >
                    {option.label}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <Box
            sx={{
              display: 'flex',
              gap: 2,
              mt: 1,
              '& .MuiFormControl-root, & .MuiTextField-root': {
                flex: 1,
                minWidth: 0,
              },
            }}
          >
            <TextField
              margin="normal"
              label={selectedContract === "CDI" ? "Salaire minimum" : "TJM minimum"}
              value={tarifMin}
              onChange={(e) => {
                const value = e.target.value === '' ? '' : Number(e.target.value);
                setTarifMin(value);
                setErrorContract('');
                if (tarifMax && Number(value) > Number(tarifMax)) {
                  setErrorContract('Le minimum doit être inférieur ou égal au maximum.');
                }
              }}
              error={tarifMin && tarifMax && Number(tarifMin) > Number(tarifMax)}
              InputProps={{
                endAdornment: currencySelector,
              }}
            />

            <TextField
              margin="normal"
              label={selectedContract === "CDI" ? "Salaire maximum" : "TJM maximum"}
              value={tarifMax}
              onChange={(e) => {
                const value = e.target.value === '' ? '' : Number(e.target.value);
                setTarifMax(value);
                setErrorContract('');
                if (tarifMin && Number(value) < Number(tarifMin)) {
                  setErrorContract('Le minimum doit être inférieur ou égal au maximum.');
                }
              }}
              InputProps={{
                endAdornment: currencySelector,
              }}
            />
          </Box>

          {/* Message d'erreur */}
          {errorContract && (
            <p className="error-message" style={{ color: 'red', marginTop: 8 }}>
              {errorContract}
            </p>
          )}
        </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpenDialog(false)}>Annuler</Button>
            <Button
              onClick={() => {
                const existing = data.typeContratDetails || [];
                const existingIndex = existing.findIndex(
                  (item) => item.contrat === selectedContract
                );

                if (!selectedContract || !tarifMax || !devise) {
                  setErrorContract('Veuillez remplir tous les champs.');
                  return;
                }

                if (Number(tarifMin) > Number(tarifMax)) {
                  setErrorContract('Le minimum doit être inférieur ou égal au maximum.');
                  return;
                }

                let updated;
                if (existingIndex !== -1) {
                  updated = [...existing];
                  updated[existingIndex] = {
                    ...updated[existingIndex],
                    tarifMin,
                    tarifMax,
                    devise,
                  };
                } else {
                  updated = [
                    ...existing,
                    { contrat: selectedContract, tarifMin, tarifMax, devise },
                  ];
                }

                onChange('typeContratDetails', updated);

                setSelectedContract('');
                setTarifMax('');
                setTarifMin('');
                setDevise('EUR');
                setErrorContract('');
                setOpenDialog(false);
              }}
            >
              Ajouter
            </Button>
          </DialogActions>
        </Dialog>



    </form>
  );
};

export default StepTwo;
